module.exports = __webpack_public_path__ + "media/images/brand/logo/tfs-share-default-a7b076808488053c10116ff0605a39a1.jpg";